











































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  trainDetail,
  trainCurrentStep,
  trainSubmit,
  trainPractice,
} from "@/api/task/train";

@Component
export default class TrainDetail extends Vue {
  private tid = "";
  private title = "";
  private steps = [];
  private current = {
    did: 0,
  };
  private stepNum = 0;
  private currentStep = {
    type: 0,
    did: 0,
  };
  private trainStatus = 0;
  private choose = "1";
  private nlpList = [];
  private practiceStatus = 0;

  private practiceUrl = "";
  private record = [];

  private total = 0;

  private created() {
    this.tid = this.getQueryVariable("id");
    this.title = decodeURI(this.getQueryVariable("title"));
    this.getDetail();
  }

  private async getDetail() {
    try {
      const data: any = await trainDetail({ tid: this.tid });
      this.$nextTick(() => {
        this.steps = data;
        this.total = data ? data.total : 0;
        this.getCurrent();
      });
    } catch (error) {
      console.log(error);
    }
  }

  private async getCurrent() {
    try {
      const data: any = await trainCurrentStep({ tid: this.tid });
      this.$nextTick(() => {
        this.resetCurrent(data);
        this.init();
      });
    } catch (error) {
      console.log(error);
    }
  }

  private resetCurrent(result) {
    let data = [];
    if (result && result.length > 0) {
      for (let i = 0; i < this.steps.length; i++) {
        for (let j = 0; j < result.length; j++) {
          if (this.steps[i].id == result[j].did) {
            data.push(result[j]);
            break;
          }
        }
      }
    }

    this.current = data ? data[data.length - 1] : {};
    this.record = data;
  }

  private async searchResult() {
    try {
      const data: any = await trainPractice({
        tid: (this.currentStep as any).question,
      });
      this.$nextTick(() => {
        if (data.result) {
          this.practiceStatus = 1;
          this.trainStatus = 1;
        } else {
          this.practiceStatus = 0;
          this.trainStatus = 0;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  private preStep() {
    if (this.stepNum != 0) {
      this.stepNum -= 1;
      this.currentStep = this.steps[this.stepNum];
      this.initStep();
    }
  }

  private async nextStep() {
    if (this.currentStep.type == 1) {
      for (let i = 0; i < this.nlpList.length; i++) {
        let value = this.nlpList[i].result;
        if (this.nlpList[i].type == 1) {
          if (value != this.nlpList[i].rightValue[0]) {
            debugger;
            this.$Notice.error({ desc: "第" + (i + 1) + "道选择题回答错误" });
            return;
          }
        } else if (this.nlpList[i].type == 2) {
          if (value.length != this.nlpList[i].rightValue.length) {
            debugger;
            this.$Notice.error({ desc: "第" + (i + 1) + "道选择题回答错误" });
            return;
          }

          let rightCount = 0;
          for (let j = 0; j < value.length; j++) {
            let right = this.nlpList[i].rightValue;
            for (let k = 0; k < right.length; k++) {
              if (value[j] == right[k]) {
                rightCount++;
              }
            }
          }

          if (rightCount != this.nlpList[i].rightValue.length) {
            this.$Notice.error({ desc: "第" + (i + 1) + "道选择题回答错误" });
            return;
          }
        }
      }
    } else if (this.currentStep.type == 2 && this.practiceStatus == 0) {
      this.$Notice.error({ desc: "请完成考核题目" });
      return;
    }

    if (this.stepNum < this.record.length) {
      this.stepNum += 1;
      if (this.stepNum == this.steps.length) {
        this.currentStep.type = -1;
      } else {
        this.currentStep = this.steps[this.stepNum];
      }

      this.initStep();
      return;
    }

    try {
      const data: any = await trainSubmit({
        tid: this.tid,
        did: (this.currentStep as any).id,
      });
      this.$nextTick(() => {
        this.getCurrent();
      });
    } catch (error) {
      console.log(error);
    }
  }

  private init() {
    this.currentStep = this.steps[0];

    if (!this.current || !this.current.did) {
      this.currentStep = this.steps[0];
    } else if (this.current.did == this.steps[this.steps.length - 1].id) {
      this.stepNum = this.steps.length;
      this.currentStep = {
        type: 0,
        did: 0,
      };
      this.currentStep.type = -1;
    } else {
      for (let i = 0; i < this.steps.length; i++) {
        if (this.current.did == this.steps[i].id) {
          this.stepNum = i + 1;
          if (i < this.steps.length - 1) {
            this.currentStep = this.steps[i + 1];
          }
        }
      }
    }

    this.initStep();
  }

  private initStep() {
    if (this.currentStep) {
      if (this.currentStep.type == 0) {
        this.trainStatus = 1;
      } else if (this.currentStep.type == 1) {
        this.trainStatus = 1;
        this.nlpList = (this.currentStep as any).nlpItems;

        if (this.nlpList.length > 0) {
          for (let i = 0; i < this.nlpList.length; i++) {
            this.nlpList[i].option = JSON.parse(this.nlpList[i].option);
            this.nlpList[i].value = "0";
            let rightValue = [];
            for (let j = 0; j < this.nlpList[i].option.length; j++) {
              let option = this.nlpList[i].option[j];

              if (option.default == 1) {
                rightValue.push(option.value);
              }
            }
            this.nlpList[i].rightValue = rightValue;

            if (this.stepNum <= this.record.length - 1) {
              if (
                this.nlpList[i].type == 1 &&
                rightValue &&
                rightValue.length > 0
              ) {
                this.nlpList[i].result = rightValue[0];
              } else if (this.nlpList[i].type == 2) {
                this.nlpList[i].result = rightValue;
              }
            }
          }
        }
      } else if (this.currentStep.type == 2) {
        this.searchResult();
        this.practiceUrl =
          "https://renwu.longmaosoft.com" + (this.currentStep as any).from;
      }
    }
  }

  private getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return "";
  }
}
